export default "__VITE_ASSET__B_pDOSh0__"